export function line(ctx) {
    return {
        // line_width: 1 / line_rounded: false already match firmware (lv_theme_material.c:392,
        // line_init() sets only line_width=1 — no color). Firmware sets no line_color at all
        // for LINE_PART_MAIN (no LV_THEME_LINE style beyond `styles->line`, which carries no
        // color) — no clear Material-theme analog for a literal color here; the muted gray
        // below is a DESIGNER-SPECIFIC visual default for canvas legibility, not a firmware
        // value. (Previously also set `bg_opa: 0` — line.js's schema has no bg_color/bg_opa
        // property at all, so that was a dead, unread override; removed.)
        styles: {
            main: { line_color: ctx.COLOR_BG_SEC_TEXT, line_width: 1, line_rounded: false },
        },
    };
}
